import styled from "styled-components"

const StyledLogo404 = styled.svg``

export const Logo404: React.FC = (props) => (
	<StyledLogo404
		version="1.1"
		viewBox="0 0 160 80"
		enableBackground="new 0 0 160 80"
		width="160"
		height="80"
	>
		<rect x="80" width="80" height="80" fill="#F0F4FA" />
		<rect width="80" height="80" fill="#D1DFF1" />
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M126.3,57h-24.5c-0.7,0-1.5-0.3-2-0.8C99.3,55.7,99,55,99,54.2V26.8c0-0.7,0.3-1.4,0.8-1.9
			c0.5-0.5,1.2-0.8,2-0.8h36.4c0.7,0,1.5,0.3,2,0.8c0.5,0.5,0.8,1.2,0.8,1.9v11.7"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M141.1,59.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3,0,0.4c0,0.1,0.1,0.3,0.2,0.4
			c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3,0,0.4,0c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2-0.1-0.4-0.2-0.5
			C141.5,59.6,141.3,59.5,141.1,59.5z"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M141.1,55.3v-5.6"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M151.9,60.3c0.3,0.5,0.4,1.1,0.3,1.6c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.5-0.7,0.9-1.2,1.1c-0.5,0.3-1,0.4-1.6,0.4
			h-15.7c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.3-0.9-0.7-1.2-1.1c-0.3-0.5-0.5-1-0.5-1.6c0-0.6,0.1-1.1,0.3-1.6l7.8-15.7
			c0.3-0.5,0.7-1,1.2-1.3c0.5-0.3,1.1-0.5,1.7-0.5c0.6,0,1.2,0.2,1.7,0.5c0.5,0.3,0.9,0.8,1.2,1.3L151.9,60.3z"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M46.2,40c-1.7-1.6-3.9-2.4-6.2-2.4s-4.5,0.9-6.2,2.4"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M36.2,30v2.5"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M43.8,30v2.5"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M55,45V26.2c0-0.7-0.3-1.3-0.7-1.8c-0.5-0.5-1.1-0.7-1.8-0.7h-25c-0.7,0-1.3,0.3-1.8,0.7
			C25.3,25,25,25.6,25,26.2V45H55z"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M58.5,52.7c0.2,0.4,0.2,0.8,0.2,1.2c0,0.4-0.2,0.8-0.4,1.2c-0.2,0.3-0.5,0.6-0.9,0.8s-0.8,0.3-1.2,0.3H23.8
			c-0.4,0-0.8-0.1-1.2-0.3c-0.4-0.2-0.7-0.5-0.9-0.8c-0.2-0.3-0.4-0.7-0.4-1.2c0-0.4,0-0.8,0.2-1.2L25,45h30L58.5,52.7z"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M37.5,51.2h5"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M123.4,42.1c0,0.8-0.3,1.6-0.9,2.1c-0.6,0.6-1.3,0.9-2.1,0.9s-1.6-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1v-4
			c0-0.8,0.3-1.6,0.9-2.1s1.3-0.9,2.1-0.9s1.6,0.3,2.1,0.9s0.9,1.3,0.9,2.1V42.1z"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M113.7,41.1h-2.8H108V35 M113.7,35v10"
		/>
		<path
			fill="none"
			stroke="#0D3050"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M132.3,41.1h-2.8h-2.8V35 M132.3,35v10"
		/>
	</StyledLogo404>
)
